/**
 * Shared Print Utility
 * Provides consistent print styling and structure across all components
 */

/**
 * Default print styles that ensure proper printing of colors, borders, and layout
 */
export const PRINT_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;600&display=swap');

  .signature-field-cursive {
    font-family: 'Dancing Script', cursive;
    font-weight: 600;
  }

  .signature-field-display-name {
    font-size: 1.5rem;
    line-height: 1.2;
  }

  .signature-field-display-name--typed {
    font-weight: 600;
  }

  @page {
    margin: 1cm;
    size: auto;
  }
  
  @media print {
    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      color-adjust: exact !important;
    }

    body {
      margin: 0;
      padding: 20px;
      font-family: Arial, sans-serif;
      background: white !important;
    }
    
    .no-print {
      display: none !important;
    }
    
    .page-break {
      page-break-before: always;
    }
    
    .page-break-avoid {
      page-break-inside: avoid;
    }
    
    .print-container {
      box-shadow: none !important;
      border-radius: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      max-width: 100% !important;
      background: transparent !important;
    }
  }
  
  body {
    font-family: Arial, sans-serif;
    padding: 20px;
    color: #333;
    background-color: #f5f5f5;
  }
      :root {
    --white: #ffffff;
    --gray-100: #f8f9fb;
    --gray-200: #eaedf2;
    --gray-300: #DBDFE9;
    --gray-400: #d4e0ed;
    --gray-500: #99A1B7;
    --gray-600: #78829D;
    --gray-700: #4B5675;
    --gray-800: #252F4A;
    --gray-900: #071437;
    --black: #0C0E18;
    --indigo: #7239EA;
    --red: #F8285A;
    --green: #01D8AE;
    --blue: #00a0d4;
    --blue-dark: #0080b3;
    --cyan: #00dbff;
    --yellow: #F6C000;
    --border-bg: var(--gray-400);
    }
    
  .print-container {
    min-width: 960px;
    width: fit-content;
    max-width: 100%;
    margin: 0 auto;
    background: white;
    padding: 30px;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
    border-radius: 8px;
  }
  
  .print-header {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(1, 1fr);
    gap: 60px;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 2px solid #333;
    page-break-after: avoid;
    page-break-inside: avoid;
  }
  
  .print-header-left {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }
    .print-header-right {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
  
  .print-header-logo {
    height: 50px;
    width: auto;
  }
  
  .print-header-text {
    display: flex;
    flex-direction: column;
  }
  
  .print-header-title {
    font-size: 16px;
    font-weight: bold;
    margin: 0;
    color: var(--gray-800);
  }
  
  .print-header-subtitle {
    font-size: 12px;
    color: var(--gray-700);
    margin: 0;
  }
  
  .print-header-content {
    flex: 1;
align-content: center;    
text-align: center;
  }
  
  .print-header-content h1 {
    margin: 0;
    font-size: 18px;
    color: var(--gray-800);
  }
  
  .print-header-right p {
    margin: 5px 0;
    color: var(--gray-800);
    font-size: 14px;
  }
  
  .print-button {
    padding: 12px 20px;
    background-color: #00a0d4;
    border: none;
    color: white;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
  }
  
  .print-button:hover {
    background-color: #0080b3;
  }
  
  .print-section {
    margin-bottom: 30px;
    page-break-inside: avoid;
  }
  
  .print-section h2 {
    font-size: 18px;
    margin-bottom: 15px;
    color: var(--gray-800);
    border-bottom: 1px solid var(--border-bg);
    padding-bottom: 10px;
  }
  
  /* Chart/Image Styles */
  .charts-container {
    display: flex;
    justify-content: space-around;
    margin-bottom: 30px;
    flex-wrap: wrap;
    gap: 20px;
  }
  
  .chart-item {
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 10px;
    min-width: 250px;
  }
  
  .chart-item-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  
  .chart-item h3 {
    font-size: 16px;
    margin-bottom: 10px;
    color: var(--gray-800);
  }
  
  .chart-svg {
    margin: 10px 0;
  }
  
  .chart-stats {
    margin-top: 10px;
    margin-left: 20px;
  }
  
  .chart-stats div {
    margin: 5px 0;
    font-size: 14px;
    color: var(--gray-800);
  }
  
  /* Table Styles */

  table {
            width: 100%;
            border-collapse: collapse;
            background: white;
            font-size: 12px;
        }

        thead {
            background: var(--gray-100);
            color: var(--gray-800);
            border-bottom: 2px solid var(--border-bg);
        }

        th {
            padding: 18px 0;
            text-align: center
            font-weight: 600;
            letter-spacing: 1px;
        }
        th:first-child {
            text-align: left;
            padding-left: 20px;
        }

        tbody tr {
            border-bottom: 1px solid var(--border-bg);
            transition: all 0.3s ease;
        }
        .schedule-table tbody tr {
            border-bottom: 1px solid #ffffff !important;
        }

        tbody tr:nth-child(even) {
            background: var(--gray-100);
        }
        .schedule-table tr:nth-child(even)  {  
            background: var(--white) !important;
        }

        tbody tr:last-child {
            border-bottom: none;
        }

        td {
            padding: 18px 24px;
            font-size: 12px;
            text-align: center;
            color: var(--gray-700);
        }

        td:first-child {
            font-weight: 600;
            color: var(--gray-800);
        }

        .status {
            display: inline-block;
            padding: 6px 14px;
            border-radius: 20px;
            font-size: 12px;
            font-weight: 600;
            text-transform: uppercase;
        }


  /* Badge Styles */
  .badge {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: bold;
    display: inline-block;
  }
  
  .badge-success {
    background-color: var(--green);
    color: white;
  }
  
  .badge-warning {
    background-color: var(--yellow);
    color: #000;
  }
  
  .badge-danger {
    background-color: var(--red);
    color: white;
  }
  
  .badge-info {
    background-color: var(--indigo);
    color: white;
  }
  
  /* Footer Styles */
  .print-footer {
    margin-top: 30px;
    text-align: center;
    font-size: 12px;
    color: var(--gray-600);
    border-top: 1px solid var(--border-bg);
    padding-top: 10px;
    page-break-inside: avoid;
  }
  
  /* Schedule Table Styles */
  
        .schedule-table th:first-child, .schedule-table td:first-child {
        text-align: left !important;
        padding-left: 20px !important;
      }
      .schedule-table td {
        text-align: center;
        border: none;
        padding: 1px;
      }
        .pgy-header {
        font-weight: bold;
        text-align: center;
        padding: 10px 24px !important;
        font-size: 14px;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
 
      .resident-cell {
        padding: 8px;
        border-radius: 4px;
        margin: 2px 0;
        background-color: #e9ecef;
        display: inline-block;
        margin-right: 4px;
        margin-bottom: 4px;
      }
      .no-residents {
        color: #6c757d;
        font-style: italic;
      }

  
  
  .rotation-cell {
    padding: 8px;
    border-radius: 6px;
    font-size: 12px;
    height: 30px;
    min-height: 30px;
    max-height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
          .rotation-cell-block {
padding: 8px;
    border-radius: 6px;
    font-size: 12px;
    height: 30px;
    min-height: 30px;
    max-height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color: white;
    width: 100%;
    }

  /* Cancelled/Strikethrough styles */
  .cancelled-item {
    opacity: 0.6;
    text-decoration: line-through;
  }
  
  /* Event label styles for calendar */
  .event-label {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    margin-left: 8px;
    color: #000 !important;
  }
`;

/**
 * Get the default logo URL
 */
export const getDefaultLogoUrl = () => {
  return `${window.location.origin}/images/asset11.svg`;
};

/**
 * Build a print header with logo and title
 * @param {Object} options - Header options
 * @param {string} options.title - Main title
 * @param {string} options.subtitle - Subtitle (optional)
 * @param {string} options.logoUrl - Logo URL (optional, defaults to default logo)
 * @param {boolean} options.showPrintButton - Whether to show print button (default: true)
 * @returns {string} HTML string for header
 */
export const buildPrintHeader = ({
  title,
  subtitle = '',
  logoUrl = null,
  showPrintButton = true,
  additionalInfo = []
}) => {
  const logo = logoUrl || getDefaultLogoUrl();
  
  // Filter out "Generated" from additional info (it goes in footer)
  const headerInfo = additionalInfo.filter(info => 
    info.label && !info.label.toLowerCase().includes('generated')
  );
  
  const additionalInfoHtml = headerInfo.length > 0
    ? headerInfo.map(info => `<p><strong>${info.label}:</strong> ${info.value}</p>`).join('')
    : '';
  
  const printButton = showPrintButton
    ? '<button class="print-button no-print" onclick="window.print()">Print</button>'
    : '';
  
  return `
    <div class="print-header">
      <div class="print-header-left">
        <img src="${logo}" alt="Logo" class="print-header-logo" onerror="this.style.display='none'" />
        <div class="print-header-text">
          <div class="print-header-title">MedHive</div>
          <div class="print-header-subtitle">Resident Management System</div>
        </div>
      </div>
      <div class="print-header-content">
        <h1>${title}</h1>
    
      </div>
      <div class="print-header-right">   
       <span>${subtitle ? `<p>${subtitle}</p>` : ''}
        ${additionalInfoHtml}</span>
        ${printButton ? `<div>${printButton}</div>` : ''}
      </div>
    </div>
  `;
};

/**
 * Build a print footer
 * @param {string} message - Footer message (optional)
 * @param {Array} additionalInfo - Additional info items to extract "Generated" date from (optional)
 * @returns {string} HTML string for footer
 */
export const buildPrintFooter = (message = 'This is a system-generated report. For questions, please contact the program director.', additionalInfo = []) => {
  // Extract "Generated" date from additionalInfo
  const generatedInfo = additionalInfo.find(info => 
    info.label && info.label.toLowerCase().includes('generated')
  );
  
  const generatedText = generatedInfo 
    ? `Generated on ${generatedInfo.value}` 
    : '';
  
  const footerText = generatedText 
    ? (message ? `${message}<br>${generatedText}` : generatedText)
    : message;
  
  return `
    <div class="print-footer">
      <p>${footerText}</p>
    </div>
  `;
};

/**
 * Build a complete print document
 * @param {Object} options - Print document options
 * @param {string} options.title - Document title
 * @param {string} options.content - Main content HTML
 * @param {string} options.headerTitle - Header title
 * @param {string} options.headerSubtitle - Header subtitle (optional)
 * @param {string} options.logoUrl - Logo URL (optional)
 * @param {boolean} options.showPrintButton - Show print button (default: true)
 * @param {Array} options.additionalHeaderInfo - Additional header info items (optional)
 * @param {string} options.footerMessage - Footer message (optional)
 * @param {string} options.customStyles - Additional custom styles (optional)
 * @param {string} options.extraHeadContent - Extra HTML for <head> (e.g. link tags) (optional)
 * @param {boolean} options.showHeader - Include MedHive logo/title strip (default: true). Shown on screen only: the strip uses class `no-print` and is hidden in print/PDF via `@media print`. When false, no header block; Print button renders above content if showPrintButton is true.
 * @param {string} options.pageSize - Page size (default: 'auto', can be 'landscape')
 * @returns {string} Complete HTML document string
 */
export const buildPrintDocument = ({
  title,
  content,
  headerTitle,
  headerSubtitle = '',
  logoUrl = null,
  showPrintButton = true,
  showHeader = true,
  additionalHeaderInfo = [],
  footerMessage = null,
  customStyles = '',
  extraHeadContent = '',
  pageSize = 'auto'
}) => {
  const pageStyle = pageSize === 'landscape' 
    ? '@page { size: landscape; margin: 1cm; }'
    : '@page { size: auto; margin: 1cm; }';
  
  const header = showHeader
    ? buildPrintHeader({
      title: headerTitle ?? title ?? '',
      subtitle: headerSubtitle,
      logoUrl,
      showPrintButton,
      additionalInfo: additionalHeaderInfo
    })
    : '';

  const printButtonOnlyBar =
    !showHeader && showPrintButton
      ? '<div class="no-print" style="margin-bottom:16px;"><button type="button" class="print-button" onclick="window.print()">Print</button></div>'
      : '';
  
  const footer = buildPrintFooter(footerMessage, additionalHeaderInfo);
  
  return `<!DOCTYPE html>
<html>
  <head>
    <title>${title}</title>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    ${extraHeadContent}
    <style>
      ${pageStyle}
      ${PRINT_STYLES}
      ${customStyles}
    </style>
  </head>
  <body>
    <div class="print-container">
      ${header}
      ${printButtonOnlyBar}
      ${content}
      
    </div>
  </body>
</html>`;
};

/**
 * Open a print window with the given content
 * @param {string} htmlContent - Complete HTML content to print
 * @param {number} delay - Delay in milliseconds before triggering print (default: 250)
 */
export const openPrintWindow = (htmlContent, delay = 250) => {
  const printWindow = window.open('', '_blank');
  if (!printWindow) {
    alert('Please allow popups to print this document.');
    return;
  }
  
  printWindow.document.write(htmlContent);
  printWindow.document.close();
  
  // Wait for content to load, then print
  setTimeout(() => {
    printWindow.print();
  }, delay);
};

/**
 * Build SVG chart for leave allotment (arc chart)
 * @param {Object} options - Chart options
 * @param {number} options.used - Used amount
 * @param {number} options.total - Total amount
 * @param {string} options.color - Chart color (default: '#007bff')
 * @param {number} options.width - SVG width (default: 160)
 * @param {number} options.height - SVG height (default: 90)
 * @returns {string} SVG HTML string
 */
export const buildLeaveAllotmentChart = ({
  used,
  total,
  color = '#007bff',
  width = 160,
  height = 90
}) => {
  const dashArray = total > 0 ? (used / total) * 219.91 : 0;
  
  return `
    <svg width="${width}" height="${height}" viewBox="0 0 180 90">
      <path
        d="M 20 70 A 50 50 0 0 1 160 70"
        fill="none"
        stroke="#e0e0e0"
        stroke-width="12"
        stroke-linecap="round"
      />
      <path
        d="M 20 70 A 50 50 0 0 1 160 70"
        fill="none"
        stroke="${color}"
        stroke-width="12"
        stroke-linecap="round"
        stroke-dasharray="${dashArray} 219.91"
      />
    </svg>
  `;
};

/**
 * Build a chart item with SVG and stats
 * @param {Object} options - Chart item options
 * @param {string} options.title - Chart title
 * @param {string} options.svgContent - SVG content
 * @param {Array} options.stats - Array of {label, value} objects
 * @returns {string} HTML string for chart item
 */
export const buildChartItem = ({ title, svgContent, stats = [] }) => {
  const statsHtml = stats.map(stat => 
    `<div><strong>${stat.label}:</strong> ${stat.value}</div>`
  ).join('');
  
  return `
    <div class="chart-item">
      <div class="chart-item-content">
        <h3>${title}</h3>
        <div class="chart-svg">
          ${svgContent}
        </div>
      </div>
      <div class="chart-stats">
        ${statsHtml}
      </div>
    </div>
  `;
};

